import LLMInteractionCategoriesContainer from "./LLMInteractionCategoriesContainer";
import {Layout} from "../../HOC/Layout/Layout";

const LLMInteractionCategories = Layout(LLMInteractionCategoriesContainer)

export default LLMInteractionCategories;